import { createRouter , createWebHistory} from "vue-router";
const app = () => import("@/App.vue")
const userLogin = () => import("@/pages/UserLogin.vue")
const userRegister = () => import("@/pages/UserRegister.vue")
const home = () => import("@/pages/Home.vue")
const orgMgr = () => import("@/pages/sysman/OrgMgr.vue")

const gisDemo = () => import("@/pages/test/GisDemo.vue")
const sysParam = () => import("@/pages/sysman/SysParam.vue")

const deviceMgr = () => import("@/pages/device/DeviceMgr.vue")
const maintain = () => import("@/pages/device/DeviceMaintain.vue")

const main = () => import("@/pages/device/Main.vue")

const electric = () => import("@/pages/device/ElectricFiled.vue")
const electricDetail = () => import("@/pages/device/ElectricDetail.vue")
const location = () => import("@/pages/device/LightningLocation.vue")
const locationDetail = () => import("@/pages/device/LightningLocationDetail.vue")
const peak = () => import("@/pages/device/LightningPeak.vue")
const peakDetail = () => import("@/pages/device/LightningPeakDetail.vue")
const resistance = () => import("@/pages/device/GroundResistance.vue")
const resistanceDetail = () => import("@/pages/device/GroundResistanceDetail.vue")
const protection = () => import("@/pages/device/LightningProtection.vue")
const protectionDetail = () => import("@/pages/device/LightningProtectionDetail.vue")
const rod = () => import("@/pages/device/LightningRod.vue")
const rodDetail = () => import("@/pages/device/LightningRodDetail.vue")

const dataDefinition = () => import("@/pages/definition/DataDefinition.vue")



const routes = [
  { 
    path: "/", 
    redirect: "/userLogin" 
  },
  {
    path: "/userLogin",
    name: "userLogin",
    component: userLogin
  },
  {
    path: "/userRegister",
    name: "userRegister",
    component: userRegister
  },
  {
    path: "/gisDemo",
    name: "gisDemo",
    component: gisDemo
  },
  {
    path: "/home",
    name: "home",
    component: home,
    redirect: "/main",
    meta:{requiresAuth: false},
    children: [
      {
        path: "/main",
        name: "main",
        component: main
      },
      {
        path: "/dataDefinition",
        name: "dataDefinition",
        component: dataDefinition
      },
      {
        path: "/orgMgr",
        name: "orgMgr",
        component: orgMgr
      },
      {
        path: "/sysParam",
        name: "sysParam",
        component: sysParam
      },
      {
        path: "/deviceMgr",
        name: "deviceMgr",
        component: deviceMgr
      },
      {
        path: "/maintain",
        name: "maintain",
        component: maintain
      },
      {
        path: "/electric",
        name: "electric",
        component: electric
      },
      {
        path: "/electricDetail/:deviceId",
        name: "electricDetail",
        component: electricDetail
      },
      {
        path: "/location",
        name: "location",
        component: location
      },
      {
        path: "/locationDetail/:deviceId",
        name: "locationDetail",
        component: locationDetail
      },
      {
        path: "/peak",
        name: "peak",
        component: peak
      },
      {
        path: "/peakDetail/:deviceId",
        name: "peakDetail",
        component: peakDetail
      },
      {
        path: "/resistance",
        name: "resistance",
        component: resistance
      },
      {
        path: "/resistanceDetail/:deviceId",
        name: "resistanceDetail",
        component: resistanceDetail
      },
      {
        path: "/protection",
        name: "protection",
        component: protection
      },
      {
        path: "/protectionDetail/:deviceId",
        name: "protectionDetail",
        component: protectionDetail
      },
      {
        path: "/rod",
        name: "rod",
        component: rod
      },
      {
        path: "/rodDetail/:deviceId",
        name: "rodDetail",
        component: rodDetail
      },
    ]
  },
  
]

export const router = createRouter({
    // history: createWebHashHistory(),
    history: createWebHistory(),
    // mode: 'history',
    routes: routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.matched.some(record => record.meta.requiresAuth) && (token == null)) {
    next({path:'/userLogin'});
  } else {
    next();
  }
})

export default router